import { MantineTheme } from "@mantine/styles";

import { ThemeComponent } from "./helpers.ts";

const goldenAccordion = (theme: MantineTheme) => ({
  control: {
    background: theme.colors.golden[0],
    color: theme.colors.white[0],
  },
});

const blueAccordion = (theme: MantineTheme) => ({
  control: {
    background: theme.colors.dusk[0],
    color: theme.colors.white[0],
  },
});

const goldenOutlineAccordion = (theme: MantineTheme) => ({
  control: {
    color: theme.colors.golden[0],
    background: theme.colors.white[0],
    border: `1px solid ${theme.colors.golden[0]}`,
  },
});

export default function accordionTheme(): ThemeComponent {
  return {
    variants: {
      goldenFilled: goldenAccordion,
      goldenOutline: goldenOutlineAccordion,
      blueFilled: blueAccordion,
    },
  };
}
